// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__hqWBV","large":"styles_large__1L62g"};